import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kickstarter-alternate',
  templateUrl: './kickstarter-alternate.component.html',
  styleUrl: './kickstarter-alternate.component.scss'
})
export class KickstarterAlternateComponent implements OnInit {
  isLoading = false;

    ngOnInit() {
  }
}

